import React from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { useNavigate } from 'react-router-dom';
import { useModules } from '../../contexts/ModulesContext';
import { Thermometer, Package, ShoppingBag, ClipboardList, ArrowRight, BookOpen, ShoppingCart } from 'lucide-react';

export const ExportsOverview = () => {
  const navigate = useNavigate();
  const { isModuleEnabled } = useModules();

  const exportCards = [
    {
      title: 'Temperatur-Export',
      description: 'Exportieren Sie alle Temperatur-Messungen als PDF',
      icon: Thermometer,
      color: 'bg-gradient-to-br from-red-50 to-orange-50',
      borderColor: 'border-red-200',
      iconColor: 'text-red-600',
      hoverColor: 'hover:border-red-400',
      route: '/admin/temperature-export',
      module: 'temperature_control'
    },
    {
      title: 'MHD-Export',
      description: 'Alle MHD-Abschriften als PDF herunterladen',
      icon: Package,
      color: 'bg-gradient-to-br from-blue-50 to-cyan-50',
      borderColor: 'border-blue-200',
      iconColor: 'text-blue-600',
      hoverColor: 'hover:border-blue-400',
      route: '/admin/mhd-export',
      module: 'mhd_control'
    },
    {
      title: 'Backshop Export',
      description: 'Backshop und TGTG Abschriften exportieren',
      icon: ShoppingBag,
      color: 'bg-gradient-to-br from-orange-50 to-amber-50',
      borderColor: 'border-orange-200',
      iconColor: 'text-orange-600',
      hoverColor: 'hover:border-orange-400',
      route: '/admin/backshop-export',
      module: 'backshop'
    },
    {
      title: 'Bestellungen Export',
      description: 'Exportieren Sie alle Bestellungen als PDF',
      icon: ShoppingCart,
      color: 'bg-gradient-to-br from-indigo-50 to-purple-50',
      borderColor: 'border-indigo-200',
      iconColor: 'text-indigo-600',
      hoverColor: 'hover:border-indigo-400',
      route: '/admin/bestellungen-export',
      module: 'bestellungen'
    },
    {
      title: 'Unterweisungen Export',
      description: 'Schulungsnachweise und Tracking-Berichte exportieren',
      icon: BookOpen,
      color: 'bg-gradient-to-br from-green-50 to-emerald-50',
      borderColor: 'border-green-200',
      iconColor: 'text-green-600',
      hoverColor: 'hover:border-green-400',
      route: '/admin/unterweisungen/export',
      module: 'unterweisungen'
    },
    {
      title: 'Allgemein Export',
      description: 'Export für allgemeine Abschriften',
      icon: ClipboardList,
      color: 'bg-gradient-to-br from-purple-50 to-pink-50',
      borderColor: 'border-purple-200',
      iconColor: 'text-purple-600',
      hoverColor: 'hover:border-purple-400',
      route: '/admin/allgemein-export',
      module: 'general_writeoffs'
    }
  ];

  // 🆕 UX FIX: Filter exports based on enabled modules - deaktivierte Module komplett entfernen
  const visibleCards = exportCards.filter(card => {
    // Nur Module anzeigen, die aktiviert sind
    return card.module && isModuleEnabled(card.module);
  });

  return (
    <DashboardLayout>
      <div className="space-y-4 sm:space-y-6 pb-6 px-2 sm:px-0">
        {/* Header - Mobile Optimized */}
        <div className="text-center sm:text-left">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold" style={{fontFamily: 'Manrope, sans-serif'}}>
            Export-Übersicht
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground mt-2">
            Wählen Sie den gewünschten Export-Typ
          </p>
        </div>

        {/* Export Cards Grid - Mobile First! */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 lg:gap-6 mt-6">
          {visibleCards.map((card, index) => {
            const Icon = card.icon;
            return (
              <Card
                key={index}
                className={`${card.color} ${card.borderColor} border-2 ${card.hoverColor} transition-all duration-200 cursor-pointer transform hover:scale-105 hover:shadow-lg active:scale-95`}
                onClick={() => navigate(card.route)}
              >
                <CardHeader className="pb-3 sm:pb-4">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <CardTitle className="text-base sm:text-lg lg:text-xl font-bold mb-2 flex items-center gap-2">
                        <Icon className={`h-5 w-5 sm:h-6 sm:w-6 ${card.iconColor} flex-shrink-0`} />
                        <span className="break-words">{card.title}</span>
                      </CardTitle>
                      <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                        {card.description}
                      </p>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="pt-0">
                  <div className="flex items-center justify-end">
                    <div className={`flex items-center gap-2 ${card.iconColor} font-semibold text-sm sm:text-base`}>
                      <span>Öffnen</span>
                      <ArrowRight className="h-4 w-4 sm:h-5 sm:w-5" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </DashboardLayout>
  );
};
